module.exports = __webpack_public_path__ + "img/case_sundata_portrait.1c3dda6d.jpg";